export const newPageNotificationModal = {
	title: "¡Todo en un solo lugar!",
	content:
		"Rediseñamos esta pantalla para que crees y gestiones tus productos con más practicidad y organización. Explora el nuevo flujo a tu propio ritmo.",
	primaryActionLabel: "Ver novedades",
};
